import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import JuryDashboard from './pages/JuryDashboard';
import AudienceDashboard from './pages/AudienceDashboard';
import AdminDashboard from './pages/AdminDashboard';
import Setup from './pages/Setup';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/jury" element={<JuryDashboard />} />
        <Route path="/audience" element={<AudienceDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/setup" element={<Setup />} />
      </Routes>
    </Router>
  );
}

export default App;
